import React from 'react'
import { Controller } from 'react-hook-form'
import InputMask from 'react-input-mask'
import { Col, Row } from 'react-bootstrap'
import { TextInput } from '/src/components/common'

import './credit_card_input_element.scss'

export const CreditCardInputElement = ({ register, control }) => {
  return (
    <div className="credit-card-input-element-container">
      <Row>
        <Col sm={12}>
          <TextInput 
            label="Card Number" 
            register={register('card_number', {
              required: true
            })} />
        </Col>
        <Col sm={6}>
          <div className="form-item card-expiry">
            <Controller
              name="card_expiry"
              control={control}
              defaultValue=""
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <InputMask
                  mask="99/99"
                  maskChar=""
                  value={field.value}
                  onChange={field.onChange}
                >
                  {(inputProps) => (
                    <TextInput
                      label="Card Expiry"
                      {...inputProps}
                    />
                  )}
                </InputMask>
              )}
            />
          </div>
        </Col>
        <Col sm={6}>
          <TextInput 
            label="CVV" 
            register={register('card_cvv', {
              required: true,
              maxLength: 4
            })} />
        </Col>
      </Row>
    </div>
  )
}
